export default "__VITE_ASSET__1abd8b88__"